import type { State } from 'model/State';

export const selectUpdatedCCDetails = (state: State) => state.mac.creditCard.ccDetails;

export const selectUpdatedCCDetailsById = (id: number, state: State) =>
  state.mac.creditCard.ccDetails?.[id]?.ifSuccess((r) => r);

export const selectEnableAutoRenewProgress = (state: State) => state.mac.creditCard.enableAutoRenew;

export const selectEnableAutoRenew = (state: State) =>
  state.mac.creditCard.enableAutoRenew?.ifSuccess((r) => r);
